<template>
    <div v-loading="allLoading">

        <div class="match-info" v-if="match">
            <div style="height: 50px;line-height: 50px">
                <span style="font-size: 20px;font-weight: 600;margin-right: 10px">赛事信息</span>
                <span style="text-decoration: underline;color: blue;cursor: pointer;"
                    @click="choiceMatchDialogVisible = true">选择赛事</span>
            </div>
            <el-descriptions :column="1">
                <el-descriptions-item label="赛事名称">{{ match.MatchName }}</el-descriptions-item>
                <el-descriptions-item label="报名时间">
                    {{ match.SignUpStartTime }} 到 {{ match.SignUpEndTime }}
                    <el-tag size="mini" type="danger" v-if="match.SignUpStatus == 2 || match.SignUpStatus == 3">{{
                        match.SignUpStatusText }}</el-tag>
                    <el-tag size="mini" type="success" v-if="match.SignUpStatus == 1">{{ match.SignUpStatusText
                        }}</el-tag>
                    <el-tag size="mini" type="info" v-if="match.SignUpStatus == 0">{{ match.SignUpStatusText }}</el-tag>
                </el-descriptions-item>
                <el-descriptions-item label="比赛时间">
                    {{ match.StartTime }} 到 {{ match.EndTime }}
                    <el-tag size="mini" type="info" v-if="match.MatchStatus == 0">{{ match.MatchStatusText }}</el-tag>
                    <el-tag size="mini" type="success" v-if="match.MatchStatus == 1">{{ match.MatchStatusText
                        }}</el-tag>
                    <el-tag size="mini" type="danger" v-if="match.MatchStatus == 2">{{ match.MatchStatusText }}</el-tag>

                </el-descriptions-item>

                <el-descriptions-item label="赛事介绍">{{ match.MatchIntroduction }}</el-descriptions-item>
            </el-descriptions>
            <el-row>
                <el-button type="warning" size="small" v-if="match.SignUpStatus == 1">截止报名</el-button>
            </el-row>
        </div>
        <div class="opr-btn">
            <div style="color: red;">*仅能对截止报名的赛事进行编排</div>
            <el-button :disabled="!match" size="small" @click="showSetRegionDialog">比赛区域({{ matchRegions.length
                }})</el-button>
            <el-button :disabled="!match" size="small" @click="showSetFrequencyDialog">设置场次</el-button>
            <el-button :disabled="!match" size="small" @click="showSetVenueProDialog">设置场次项目</el-button>
            <el-button :disabled="!match" size="small" @click="showSetArrangeRuleDialog">设置编排规则</el-button>
            <el-button :disabled="!match" size="small" @click="initProjectGrouping">项目编排</el-button>
            <el-button :disabled="!match" size="small" @click="exportMatchSchedule">导出赛程</el-button>

        </div>

        <div v-if="false" class="matchWholeSchedule" style="width: 1200px;margin-top: 10px;color: #000;">
            <div>
                <el-button size="small" @click="clearMatchProjectReferenceTime()">清空参考时间</el-button>
                <el-button size="small" @click="showProjectTimeTakenConfigDialog()">生成参考时间</el-button>
                <el-button size="small" @click="exportMatchProjectTime()">导出场次项目</el-button>
            </div>
            <div v-for="item in matchWholeSchedule">
                <div
                    style="font-size: 20px; height: 50px;line-height: 50px;text-align: center;color: #fff;font-weight: 600;background-color: #409EFF;">
                    {{ item.VenueName }} ({{ item.VenueTime.replace('T', ' ') }}~{{ item.VenueEndTime.replace('T', ' ')
                    }})
                </div>



                <div>
                    <el-table :data="item.MatchVenueProject" border size="mini">
                        <el-table-column label="项次" width="105">
                            <template v-slot="scope">{{ scope.$index + 1 }}</template>
                        </el-table-column>
                        <el-table-column label="参考时间" width="150">
                            <template v-slot="scope">
                                <el-time-picker size="small" v-model="scope.row.Project.ReferenceTime" format="HH:mm"
                                    style="width: 100px;" @change="ReferenceTimeChange(scope.row.Project)">
                                </el-time-picker>
                            </template>
                        </el-table-column>
                        <el-table-column label="项目名称" width="400">
                            <template v-slot="scope">
                                {{ scope.row.Project.GroupTypeName }}
                                {{ scope.row.Project.GroupName }}
                                {{ scope.row.Project.GenderRuleText }}
                                {{ scope.row.Project.ProjectName }}
                            </template>
                        </el-table-column>
                        <el-table-column label="项目类型" width="120">
                            <template v-slot="scope">
                                {{ scope.row.Project.ProjectTypeName }}
                            </template>
                        </el-table-column>
                        <el-table-column label="组数" width="120">
                            <template v-slot="scope">
                                {{ scope.row.Project.ContestantUserGroupNum }}
                            </template>
                        </el-table-column>
                        <el-table-column label="人数/队" width="120">
                            <template v-slot="scope">
                                {{ scope.row.Project.ContestantUserNum }}
                            </template>
                        </el-table-column>

                    </el-table>
                </div>
            </div>
        </div>

        <div class="matchWholeSchedule" style="width: 1300px;margin-top: 10px;color: #000;">
            <div style="margin-bottom: 10px;">
                <el-button size="small" @click="clearMatchProjectReferenceTime()">清空参考时间</el-button>
                <el-button size="small" @click="showProjectTimeTakenConfigDialog()">生成参考时间</el-button>
                <el-button size="small" @click="exportMatchProjectTime2()">导出场次项目</el-button>
                <el-button size="small" @click="getMatchSchedule()">刷新</el-button>
            </div>
            <div v-for="item in matchSchedule">
                <div
                    style="font-size: 20px; height: 50px;line-height: 50px;text-align: center;color: #fff;font-weight: 600;background-color: #409EFF;">
                    {{ item.VenueName }} ({{ item.VenueTime.replace('T', ' ') }}~{{ item.VenueEndTime.replace('T', ' ')
                    }})
                </div>



                <div>
                    <el-table :data="item.ProjectMergeGroups" border size="mini">
                        <!-- <el-table-column type="selection" width="55">
                           
                        </el-table-column> -->
                        <el-table-column label="项次" width="80" align="center">
                            <template v-slot="scope">{{ scope.$index + 1 }}</template>
                        </el-table-column>
                        <el-table-column label="参考时间" width="150">
                            <template v-slot="scope">
                                <el-time-picker size="small" v-model="scope.row.ReferenceTime" format="HH:mm"
                                    style="width: 100px;" @change="ReferenceTimeChange2(scope.row)">
                                </el-time-picker>
                            </template>
                        </el-table-column>
                        <el-table-column label="项目名称" width="400">
                            <template v-slot="scope">
                                <el-tooltip placement="right" effect="light">
                                        <div slot="content">
                                            <div v-for="p in scope.row.Projects">{{ p.GroupName + ' ' + p.GenderRuleText + ' ' +
                                                p.ProjectName }}
                                            </div>
                                        </div>

                                        <el-tag size="mini">{{ scope.row.ProjectName }}</el-tag>
                                    </el-tooltip>
                            </template>

                            
                        </el-table-column>
                        <el-table-column label="项目类型" width="120">
                            <template v-slot="scope">
                                {{ scope.row.ProjectTypeName }}
                            </template>
                        </el-table-column>
                        <el-table-column label="赛场" width="120">
                            <template v-slot="scope">
                                {{ scope.row.RegionName }}
                            </template>
                        </el-table-column>
                        <el-table-column label="人数/队" width="100">
                            <template v-slot="scope">
                                {{ scope.row.ContestantUserNum }}
                            </template>
                        </el-table-column>
                        <el-table-column label="每组人数" width="100">
                            <template v-slot="scope">
                                {{ scope.row.ArrangeNum }}
                            </template>
                        </el-table-column>
                        <el-table-column label="组数" width="100">
                            <template v-slot="scope">
                                {{ scope.row.ContestantUserGroupNum }}
                            </template>
                        </el-table-column>


                    </el-table>
                </div>
            </div>
        </div>

        <el-dialog title="选择赛事" :visible.sync="choiceMatchDialogVisible" :close-on-press-escape="false"
            :show-close="false" width="500px">

            <div style="text-align: center;">
                <el-select clearable filterable remote reserve-keyword placeholder="请输入关键词" size="small"
                    :remote-method="remoteMethod" v-model="matchId">
                    <el-option v-for="item in matchOptions" :label="item.MatchName" :value="item.MatchId">
                    </el-option>
                </el-select>
            </div>

            <span slot="footer" class="dialog-footer">
                <el-button type="primary" size="small" @click="confirmChoiceMatch">确定</el-button>
            </span>
        </el-dialog>

        <el-dialog title="场次设置" :visible.sync="setFrequencyDialog" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false"
            width="1000px">

            <div style="text-align: center;">
                <el-table :data="frequencyData" style="width: 800px; margin: 0 auto;">
                    <el-table-column prop="VenueName" label="场次名称" width="230" />
                    <el-table-column prop="VenueTime" label="开始时间" width="180" :formatter="dataformatter" />
                    <el-table-column prop="VenueEndTime" label="截止时间" width="180" :formatter="dataformatter" />
                    <el-table-column prop="date" label="操作" width="180">
                        <template v-slot="scoped">
                            <el-button circle icon="el-icon-caret-top" size="mini" :disabled="scoped.$index == 0"
                                @click="setVenueSort(scoped.$index, 'top')"></el-button>
                            <el-button circle icon="el-icon-caret-bottom" size="mini"
                                :disabled="scoped.$index == frequencyData.length - 1"
                                @click="setVenueSort(scoped.$index, 'bottom')"></el-button>
                            <el-button circle icon="el-icon-edit" size="mini"
                                @click="initVenueForm(scoped.row, scoped.$index)"></el-button>
                            <el-button circle type="danger" icon="el-icon-delete" size="mini"
                                @click="deleteVenue(scoped.row)"></el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div style="width: 950px;margin: 0 auto;margin-top: 30px;">
                <el-form :inline="true" :model="venueForm" ref="venueForm" :rules="venueFormRules"
                    class="demo-form-inline">
                    <el-form-item label="名称" prop="VenueName">
                        <el-input v-model="venueForm.VenueName" size="mini" placeholder="名称"></el-input>
                    </el-form-item>
                    <el-form-item label="开始时间" prop="VenueTime">
                        <el-date-picker v-model="venueForm.VenueTime" style="width: 185px;" size="mini" type="datetime"
                            placeholder="选择日期">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="截止时间" prop="VenueEndTime">
                        <el-date-picker v-model="venueForm.VenueEndTime" style="width: 185px;" size="mini"
                            type="datetime" placeholder="选择日期">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" size="mini" @click="editVenue">{{ venueSubmitBtnText }}</el-button>
                        <el-button size="mini" type="info" @click="initVenueForm(null, -1)">取消</el-button>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button size="small" @click="setFrequencyDialog = false">关闭</el-button>
            </span>
        </el-dialog>

        <el-dialog title="编辑报名信息" :close-on-click-modal="false" :close-on-press-escape="false" :visible.sync="editSignUpDialogVisible" width="800px">
            <el-form :model="editUserForm" ref="editUserForm" :rules="editUserFormRules"
                style="width: 80%;margin: 0 auto;" label-width="100px">
                <el-form-item label="项目" prop="ProjectId">
                    <el-select v-model="editUserForm.ProjectId" placeholder="请选择项目">
                        <el-option v-for="item in editProjects" :key="item.ProjectId"
                            :label="item.GroupName + item.GenderRuleText + item.ProjectName" :value="item.ProjectId">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="运动员" prop="UserName">
                    <el-input type="textarea" v-model="editUserForm.UserName" size="small"></el-input>
                </el-form-item>

                <el-form-item label="比赛区域" prop="RegionName">
                    <el-input v-model="editUserForm.RegionName" disabled />
                </el-form-item>

                <el-form-item label="组别" prop="ComeOnGroup">
                    <el-select v-model="editUserForm.ComeOnGroup" placeholder="请选择组别">
                        <el-option v-for="item in optionalGroups" :key="item.value" :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                    <span style="color: red;display: block;"
                        v-if="optionalGroups.length == 0">当前存在的组别都已比赛，请新增分组后再添加运动员</span>
                </el-form-item>
                <el-form-item label="生日">
                    <el-date-picker v-model="editUserForm.Birthday" type="date" placeholder="选择日期" size="small">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="身份证号">
                    <el-input type="textarea" v-model="editUserForm.IdentityCard" size="small"></el-input>
                </el-form-item>
                <el-form-item label="单位/学校" prop="Unit">
                    <el-autocomplete class="inline-input" v-model="editUserForm.Unit" :fetch-suggestions="querySearch"
                        placeholder="请输入单位/学校" style="width: 100%;"></el-autocomplete>
                </el-form-item>
                <el-form-item label="报名时间" prop="SignUpTime">
                    <el-date-picker v-model="editUserForm.SignUpTime" type="datetime" placeholder="选择日期" size="small">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="备注">
                    <el-input type="textarea" v-model="editUserForm.Remarks" size="small"></el-input>
                </el-form-item>

            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editSignUpDialogVisible = false" size="small">取 消</el-button>
                <el-button type="primary" @click="submitSignUpForm" size="small">确 定</el-button>
            </span>
        </el-dialog>


        <el-dialog title="设置编排规则" :visible.sync="setArrangeRuleDialogVisible" :close-on-click-modal="false" :close-on-press-escape="false"
            :show-close="false" width="1000px" top="50px" :fullscreen='true'>
            <div :style="{ height: windowHeight }" style="overflow: hidden; overflow-y: auto;">
                <el-collapse>
                    <el-collapse-item v-for="(item, index) in arrangeRuleData" :name="index">
                        <template slot="title">
                            <span style="font-weight: 600;">{{ item.VenueName }}</span>
                        </template>
                        <el-table :data="item.MatchVenueProject" size="mini">
                            <el-table-column prop="GroupName" label="项目组别" width="300" align="center">
                                <template v-slot="scope">
                                    {{ scope.row.Project.GroupTypeName }}
                                    {{ scope.row.Project.GroupName }}
                                </template>
                            </el-table-column>
                            <el-table-column prop="ProjectTypeName" label="项目类别" width="150" align="center">
                                <template v-slot="scope">
                                    {{ scope.row.Project.ProjectTypeName }}
                                </template>
                            </el-table-column>
                            <el-table-column prop="ProjectName" label="项目名称" width="300" align="center">
                                <template v-slot="scope">
                                    {{ scope.row.Project.ProjectName }}({{ scope.row.Project.GenderRuleText }})
                                </template>
                            </el-table-column>
                            <el-table-column label="比赛区域" width="300" align="center">
                                <template v-slot="scope">
                                    <!-- <el-checkbox-group v-model="scope.row.Project.RegionIdArr">
                                        <el-checkbox v-for="r in matchRegions" :label="r.RegionId" :key="r.RegionId">{{
                                            r.RegionName }}{{ r.IsDefault == 1 ? '(默认)' : '' }}</el-checkbox>
                                    </el-checkbox-group> -->
                                    <el-radio-group v-model="scope.row.Project.RegionIds">
                                        <el-radio v-for="r in matchRegions" :label="r.RegionId" :key="r.RegionId">{{
                                            r.RegionName }}{{ r.IsDefault == 1 ? '(默认)' : '' }}</el-radio>
                                    </el-radio-group>
                                </template>
                            </el-table-column>
                            <el-table-column prop="ContestantUserNum" label="报名人数/队" width="100" align="center">
                                <template v-slot="scope">
                                    {{ scope.row.Project.ContestantUserNum }}
                                </template>
                            </el-table-column>
                            <el-table-column label="人数设定" width="400" align="center">
                                <template slot-scope="scope">
                                    <el-row>
                                        <!-- <el-radio :label="0" v-model="scope.row.Project.ArrangeType">人</el-radio> -->
                                        <!-- <el-radio :label="1" v-model="scope.row.ArrangeType">组</el-radio> -->
                                        <span v-if="scope.row.Project.ArrangeType == 0">每</span>
                                        <span v-if="scope.row.Project.ArrangeType == 1">分为</span>
                                        <el-input-number v-model="scope.row.Project.ArrangeNum"
                                            controls-position="right" :min="1" size="small"
                                            style="width: 100px;margin: 0 10px"></el-input-number>
                                        <span v-if="scope.row.Project.ArrangeType == 0">人/队一组</span>
                                        <span v-if="scope.row.Project.ArrangeType == 1">组</span>
                                    </el-row>
                                </template>
                            </el-table-column>
                            <el-table-column label="操作">
                                <template v-slot="scope">
                                    <el-button circle icon="el-icon-caret-top" size="mini" :disabled="scope.$index == 0"
                                        @click="setVenueProjectSort2($event, index, scope.$index, 'top')"></el-button>
                                    <el-button circle icon="el-icon-caret-bottom" size="mini"
                                        :disabled="scope.$index == item.MatchVenueProject.length - 1"
                                        @click="setVenueProjectSort2($event, index, scope.$index, 'bottom')"></el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-collapse-item>
                </el-collapse>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button size="small" @click="matchArrangeOverview">预览</el-button>
                <el-button size="small" @click="submitArrangeRule" type="primary">提交</el-button>
                <el-button size="small" @click="setArrangeRuleDialogVisible = false" type="danger">关闭</el-button>
            </span>
        </el-dialog>

        <el-dialog title="编排项目预览" :visible.sync="arrangeRuleOverviewDialogVisible" :close-on-click-modal="false" :close-on-press-escape="false"
            :show-close="true" width="1200px" top="50px">
            <div>
                <el-collapse>
                    <el-collapse-item v-for="(item, index) in ArrangeRuleOverviewData" :name="index">
                        <template slot="title">
                            <span style="font-weight: 600;">{{ item.VenueName }}</span>
                        </template>
                        <el-table :data="item.ProjectMergeGroups" size="mini">
                            <!-- <el-table-column prop="GroupName" label="项目组别" width="200" align="center">
                            </el-table-column> -->
                            <el-table-column prop="ProjectTypeName" label="项目类别" width="300" align="center">
                            </el-table-column>
                            <el-table-column prop="ProjectName" label="项目名称" width="300" align="center">
                            </el-table-column>
                            <el-table-column label="合并项目数" width="80" align="center">
                                <template v-slot="scope">
                                    <el-tooltip placement="right" effect="light">
                                        <div slot="content">
                                            <div v-for="p in scope.row.Projects">{{ p.GroupName + p.GenderRuleText +
                                                p.ProjectName }}
                                            </div>
                                        </div>

                                        <el-tag size="mini">{{ scope.row.Projects.length }}</el-tag>
                                    </el-tooltip>

                                </template>
                            </el-table-column>
                            <el-table-column label="比赛区域" prop="RegionName" width="150" align="center">
                            </el-table-column>
                            <el-table-column prop="ContestantUserNum" label="报名人数/队" width="100" align="center">
                            </el-table-column>
                            <el-table-column label="每组人/队" width="100" prop="ArrangeNum" align="center">
                            </el-table-column>
                            <el-table-column label="组数" width="50" prop="ContestantUserGroupNum" align="center">
                            </el-table-column>
                        </el-table>
                    </el-collapse-item>
                </el-collapse>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button size="small" @click="submitArrangeRule" type="primary">提交</el-button>
                <el-button size="small" @click="arrangeRuleOverviewDialogVisible = false" type="danger">关闭</el-button>
            </span>
        </el-dialog>


        <el-dialog title="项目编排（按ESC关闭）" :visible.sync="projectGroupingDialog" :close-on-press-escape="true"
            :show-close="true" :fullscreen='true'>

            <div v-loading="allLoading">
                <div v-if="signUpFormStatus" style="margin-bottom: 10px;">报名表：
                    未审核（{{ signUpFormStatus.unreviewed }}），
                    已审核已处理（{{ signUpFormStatus.reviewed1 }}），
                    已审核未处理（{{ signUpFormStatus.reviewed2 }}）
                    <el-button size="mini" icon="el-icon-refresh" circle @click="checkSignUpFormStatus"></el-button>
                </div>
                <div style="margin: 5px 0;">
                    <span style="margin-right: 10px;">编排方式</span>
                    <el-radio v-model="arrangeOrderType" label="Random">随机</el-radio>
                    <el-radio v-model="arrangeOrderType" label="SignUpTime">根据报名时间</el-radio>
                    <el-button type="primary" size="mini" @click="projectArrangeV2('')">开始编排</el-button>
                </div>
                <div style="margin: 30px 0;">
                    <el-switch v-model="showNullProject" active-text="" inactive-text="显示无人报名的项目">
                    </el-switch>
                </div>
                <div class="" v-for="(venue, index) in venues">
                    <h2 style="color:chocolate;margin: 15px 0 5px 0;">
                        <!-- {{ venue.VenueName }} -->

                        <!-- <i class="el-icon-refresh" style="margin-right: 20px;" v-if="pro.ContestantUserNum > 0"
                            @click="projectArrange(pro.ProjectId)"></i> -->


                    </h2>
                    <div v-for="group in venue.ProjectMergeGroups">
                        <h2 style="color:chocolate;margin: 15px 0 5px 0;">
                            {{ group.GroupName }} {{ group.ProjectName }}({{ group.GenderRuleText }})
                            {{ group.ContestantUserNum }}人/队
                            <el-dropdown size="mini" @command="handAddRegion">
                                <el-button size="small">
                                    添加比赛区域<i class="el-icon-arrow-down el-icon--right"></i>
                                </el-button>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item v-for="ritem in matchRegions"
                                        :disabled="group.MatchRegions.filter(a => a.RegionId == ritem.RegionId).length > 0"
                                        :command="{ group: group, region: ritem }">{{
                                            ritem.RegionName }}</el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                        </h2>
                        <div v-for="r in group.MatchRegions" :key="r.RegionId">
                            <div style="width: 100%;height: 50px;line-height: 50px;background-color: #409EFF;">
                                <span
                                    style="font-size: 22px;padding:0 10px 0 30px;box-sizing: border-box;color: #fff;">{{
                                        r.RegionName }}</span>
                                <el-button size="mini" @click="addGroup(group.MatchRegions, r)">添加组别</el-button>
                                <el-button size="mini" @click="showEditUserDialog(group.Projects, r)">添加运动员</el-button>
                            </div>
                            <el-table :data="r.ContestantUserGroups" border :show-header="false"
                                :highlight-current-row="false" empty-text="暂无报名记录">
                                <el-table-column width="100" style="text-align: center;">
                                    <template v-slot="scope">
                                        <div style="font-weight: 600;text-align: center">
                                            第{{ scope.row.GroupNum }}组
                                        </div>
                                    </template>
                                </el-table-column>
                                <el-table-column>
                                    <template v-slot="scope">
                                        <div style="display: flex;width: 100%;color: #000;flex-wrap: wrap;">
                                            <div :style="{ borderColor: exchangeUsers.UserId == '' || exchangeUsers.UserId != user.UserId ? '#EBEEF5' : 'red' }"
                                                style="width: 10%;border: 1px solid;
                                            min-height: 50px;
                                            text-align: center;cursor: pointer;"
                                                v-for="(user, index) in scope.row.ContestantUsers"
                                                @dblclick="handleDoubleClickUser(group.ConfigId, r.RegionName, r.RegionId, user, index)">
                                                <div style="position: relative; border-bottom: 1px solid #EBEEF5;">
                                                    {{ user.GroupName }}
                                                </div>
                                                <div style="position: relative; border-bottom: 1px solid #EBEEF5;">{{
                                                    user.UserName ==
                                                        '' ?
                                                        '' :
                                                        user.ComeOnNum + '号' }}
                                                    <div style="position: absolute;right: 0;top: 0;">
                                                        <el-tag size="mini" v-if="user.ProjectGenderRule == 0">
                                                            男子
                                                        </el-tag>
                                                        <el-tag type="danger" size="mini"
                                                            v-if="user.ProjectGenderRule == 1">
                                                            女子
                                                        </el-tag>
                                                        <el-tag type="warning" size="mini"
                                                            v-if="user.ProjectGenderRule == 2">
                                                            混合
                                                        </el-tag>
                                                    </div>

                                                </div>
                                                <div style="padding: 3px;box-sizing: border-box;">{{ user.UserName
                                                    }}
                                                </div>
                                                <div style="padding: 3px;box-sizing: border-box;">{{ user.Unit }}
                                                </div>
                                            </div>
                                        </div>

                                        <!-- <el-descriptions direction="vertical" :column="10" border size="mini">
                                        <el-descriptions-item style="width: 10px;"  v-for="(user, index) in scope.row.ContestantUsers"
                                            :label="user.UserName == ''?'': index + 1 + '号'" size="mini">{{ user.UserName
                                            }}</el-descriptions-item>
                                    </el-descriptions> -->
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                    </div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button size="small" @click="projectGroupingDialog = false">关闭</el-button>
            </span>
        </el-dialog>

        <el-dialog title="场次项目设置" :visible.sync="setVenueProDialogVisible" :close-on-press-escape="false"
            :show-close="false" width="85%" top="50px">
            <div style="display: flex;width: 100%;height: 100%;">
                <div style="width: 40%;height: 100%;">
                    <div style="margin:0 5px 5px;display: flex;">
                        <el-button size="small" @click="allChecked(1)">全选</el-button>
                        <el-button size="small" @click="allChecked(0)">反选</el-button>
                        <el-input size="small" v-model="searchKey" style="width: 200px;margin-left: 10px"
                            placeholder="关键词查询" />
                    </div>
                    <div style="margin: 5px;">
                        <el-checkbox-group v-model="selectedNotSetProjects">
                            <el-checkbox
                                v-if="marryKey(item.GroupTypeName + '【' + item.ProjectTypeName + '】' + item.GroupName + item.GenderRuleText + item.ProjectName, searchKey)"
                                style="display: block;margin-bottom: 10px;" v-for="item in notSetProjects"
                                :key="item.ProjectId" :label="item.ProjectId">

                                {{ item.GroupTypeName }}
                                【{{ item.ProjectTypeName }}】{{ item.GroupName }}{{
                                    item.GenderRuleText }}{{
                                    item.ProjectName
                                }}
                                <span style="color: rgb(177 172 172);">
                                    （{{ item.ContestantUserNum }}人/队）
                                </span>
                            </el-checkbox>
                        </el-checkbox-group>
                    </div>
                </div>
                <div style="width: 20%;height: 100%;background-color: #e3e3e3;text-align: center;">
                    <div style="margin: 20px 10px;">
                        <el-select v-model="venueId">
                            <el-option v-for="item in matchVenues" :value="item.VenueId"
                                :label="item.VenueName"></el-option>
                        </el-select>
                    </div>
                    <div style="margin: 20px 10px;">
                        <el-button size="small" style="font-size: 20px;" type="primary" icon="el-icon-caret-right"
                            @click="toSet" :disabled="selectedNotSetProjects.length == 0"></el-button>
                    </div>
                    <div style="margin: 20px 10px;">
                        <el-button size="small" style="font-size: 20px;" type="primary" icon="el-icon-caret-left"
                            @click="cancelSet" :disabled="selectedAlreadySetProjects.length == 0"></el-button>
                    </div>

                    <div style="margin: 20px 10px;">
                        <el-button size="small" type="primary" @click="handlerMatchVenueProject">提交</el-button>
                    </div>
                    <div style="margin: 20px 10px;">
                        <el-button size="small" @click="initVenueProjectConfig">刷新</el-button>
                    </div>
                    <div style="margin: 20px 10px;">
                        <el-button type="info" size="small" @click="setVenueProDialogVisible = false">关闭</el-button>
                    </div>

                </div>
                <div style="width: 40%;height: 100%;margin-left: 10px">
                    <div style="margin:0 5px 5px;">
                        <el-button size="small" @click="alreadySetProjectsAllChecked(1)">全选</el-button>
                        <el-button size="small" @click="alreadySetProjectsAllChecked(0)">反选</el-button>
                    </div>
                    <el-checkbox-group v-model="selectedAlreadySetProjects">
                        <div v-for="(item, index) in alreadySetProjects">
                            <h3
                                style="margin-bottom: 5px; text-align: center;height: 30px;line-height: 30px;background-color: aliceblue;color: brown;">
                                [{{ item.VenueName }}]</h3>
                            <el-checkbox style="display: block;margin: 10px 0;"
                                v-for="(pro, subIndex) in item.MatchVenueProject" :key="pro.ProjectId"
                                :label="pro.ProjectId">
                                {{ pro.Project.GroupTypeName }}
                                【{{ pro.Project.ProjectTypeName }}】
                                {{ pro.Project.GroupName }}
                                {{ pro.Project.GenderRuleText }}
                                {{ pro.Project.ProjectName }}
                                <span style="color: rgb(177 172 172);">
                                    （{{ pro.Project.ContestantUserNum
                                    }}人/队）
                                </span>
                                <el-button circle icon="el-icon-caret-top" size="mini" :disabled="subIndex == 0"
                                    @click="setVenueProjectSort($event, index, subIndex, 'top')"></el-button>
                                <el-button circle icon="el-icon-caret-bottom" size="mini"
                                    :disabled="subIndex == item.MatchVenueProject.length - 1"
                                    @click="setVenueProjectSort($event, index, subIndex, 'bottom')"></el-button>
                            </el-checkbox>
                        </div>


                    </el-checkbox-group>

                </div>
            </div>

            <span slot="footer" class="dialog-footer">
                <el-button size="small" @click="setVenueProDialogVisible = false">关闭</el-button>
            </span>
        </el-dialog>

        <el-dialog title="裁判人数设置" :visible.sync="setRefereeDialogVisible" :close-on-press-escape="false"
            :show-close="false" width="600px">
            <div style="width: 100%;height: 100%;">
                <h3 style="color: red">*裁判人数决定可登录评分端人数进行打分</h3>

                <div v-for="(type, pIndex) in projectTypes">
                    <h3
                        style="height: 40px;line-height: 40px;background-color: #409EFF;margin: 5px 0;color: #fff;padding-left: 10px;">
                        {{
                            type.ProjectTypeName }}</h3>
                    <el-form label-width="180px">
                        <el-form-item v-for="(item, index) in type.RefereePeopleConfig" :label="item.RefereeTypeName">
                            <el-input-number v-model="item.RefereePeopleNum" controls-position="right" :min="1"
                                :max="10"></el-input-number>
                        </el-form-item>
                    </el-form>
                </div>


            </div>
            <span slot="footer" class="dialog-footer">

                <el-button type="primary" size="small" @click="submitEditMatchRefereeConfig()">提交</el-button>
                <el-button size="small" @click="setRefereeDialogVisible = false">关闭</el-button>
            </span>
        </el-dialog>

        <el-dialog title="比赛区域设置" :visible.sync="setRegionDialogVisible" :close-on-press-escape="false"
            :show-close="false" width="800px">
            <div style="width: 100%;height: 100%;">
                <el-table :data="matchRegions">
                    <el-table-column label="区域名称" prop="RegionName" width="300" />
                    <el-table-column label="是否默认">
                        <template slot-scope="scope">
                            {{ scope.row.IsDefault == 1 ? '是' : '' }}
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" width="180">
                        <template slot-scope="scoped">
                            <el-button circle icon="el-icon-caret-top" size="mini" :disabled="scoped.$index == 0"
                                @click="setRegionSort(scoped.$index, 'top')"></el-button>
                            <el-button circle icon="el-icon-caret-bottom" size="mini"
                                :disabled="scoped.$index == matchRegions.length - 1"
                                @click="setRegionSort(scoped.$index, 'bottom')"></el-button>
                            <el-button circle icon="el-icon-edit" size="mini"
                                @click="initRegionForm(scoped.row, scoped.$index)"></el-button>
                            <el-button circle type="danger" icon="el-icon-delete" size="mini"
                                @click="deleteRegion(scoped.row)"></el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div style="width: 700px;margin: 0 auto;margin-top: 30px;">
                    <el-form :inline="true" :model="regionForm" ref="regionForm" :rules="regionFormRules"
                        class="demo-form-inline">
                        <el-form-item label="区域名称" prop="RegionName">
                            <el-input v-model="regionForm.RegionName" size="small" placeholder="名称"></el-input>
                        </el-form-item>
                        <el-form-item label="是否默认" prop="IsDefault">
                            <el-radio-group v-model="regionForm.IsDefault">
                                <el-radio :label="1">是</el-radio>
                                <el-radio :label="0">否</el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" size="small" @click="editRegion">{{ regionSubmitBtnText
                                }}</el-button>
                            <el-button size="small" type="info" @click="initRegionForm(null, -1)">取消</el-button>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">

                <!-- <el-button type="primary" size="small" @click="submitEditMatchRefereeConfig()">提交</el-button> -->
                <el-button size="small" @click="setRegionDialogVisible = false">关闭</el-button>
            </span>
        </el-dialog>

        <el-dialog title="项目时间设置" :visible.sync="projectTimeTakenConfigDialogVisible" :close-on-press-escape="true"
            :show-close="false" width="800px">
            <div>
                <el-table :data="matchProjectTimeTakenConfig" size="small">
                    <el-table-column label="项目名称" prop="ProjectName" width="300" />
                    <el-table-column label="每组耗时（秒）" width="300">
                        <template slot-scope="scope">
                            <el-input-number size="mini" v-model="scope.row.TimeValue" controls-position="right"
                                :min="1" :max="1000"></el-input-number>
                        </template>
                    </el-table-column>
                </el-table>

            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="danger" size="small" @click="getMatchProjectTimeTakenConfig(1)">更新最新项目数据</el-button>
                <el-button type="primary" size="small" @click="submitEditMatchProjectTimeTakenConfig2()">提交</el-button>
                <el-button size="small" @click="projectTimeTakenConfigDialogVisible = false">关闭</el-button>
            </span>
        </el-dialog>

    </div>
</template>

<script>
import MatchService from '@/request-server/request-services/match-services.js';
import Common from '@/utils/utils-common.js';
import Url from '../../../request-server/request-url';
import utilsCommon from '../../../utils/utils-common';
export default {
    data() {
        return {

            text: [],
            matchId: '',
            routeMatchId: '',
            allLoading: false,
            match: {},
            allMatchs: [],
            matchOptions: [],
            choiceMatchDialogVisible: false,
            setFrequencyDialog: false,
            projectGroupingDialog: false,
            setArrangeRuleDialogVisible: false,
            arrangeRuleOverviewDialogVisible: false,
            setVenueProDialogVisible: false,
            setRegionDialogVisible: false,
            showNullProject: true,
            arrangeOrderType: 'Random',
            GenderRuleList: [{ label: '男子', value: 0 }, { label: '女子', value: 1 }, { label: '男女混合', value: 2 }],
            frequencyData: [],
            venueFormIndex: -1,
            venueSubmitBtnText: '新增',
            venueForm: {
                VenueId: '',
                MatchId: '',
                VenueName: '',
                VenueTime: '',
                VenueEndTime: '',
                VenueSort: 0

            },
            venueFormRules: {
                VenueName: [
                    { required: true, message: '请输入名称', trigger: 'blur' },
                ],
                VenueTime: [
                    { required: true, message: '请输入开始时间', trigger: 'blur' },
                ],
                VenueEndTime: [
                    { required: true, message: '请输入截止时间', trigger: 'blur' },
                ]
            },
            regionForm: {
                RegionId: '',
                MatchId: '',
                RegionName: '',
                IsDefault: 0,
                RegionSort: 0,
            },
            regionFormRules: {
                RegionName: [
                    { required: true, message: '请输入名称', trigger: 'blur' },
                ],

            },
            regionFormIndex: -1,
            regionSubmitBtnText: '新增',
            projects: [],
            venues: [],
            exchangeUsers: {
                UserId: '',
                ComeOnNum: 0,
                MergeConfigId: '',
                ComeOnGroup: 0,
            },
            matchVenues: [],
            alreadySetProjects: [],
            notSetProjects: [],
            venueId: '',
            selectedNotSetProjects: [],
            selectedAlreadySetProjects: [],
            matchWholeSchedule: [],
            setRefereeDialogVisible: false,
            setRefereeType: '0',
            projectTypes: [],
            allRefereeType: [],
            editSignUpDialogVisible: false,
            editProjects: [],
            editUserForm: {
                UserId: '',
                UserName: '',
                Gender: 0,
                Birthday: null,
                MatchId: '',
                GroupId: '',
                ProjectId: '',
                SignUpTime: null,
                IdentityCard: '',
                Unit: '',
                Remarks: '',
                RegionName: '',
                ComeOnRegion: '',
                ComeOnGroup: '',
                ComeOnNum: 0,
                SignUpTime: new Date()
            },
            searchKey: '',
            searchKey1: '',
            editUserFormRules: {
                MatchId: [
                    { required: true, message: '请输入赛事', trigger: 'blur' },
                ],

                ProjectId: [
                    { required: true, message: '请选择项目', trigger: 'blur' },
                ],
                Gender: [
                    { required: true, message: '请选择性别', trigger: 'blur' },
                ],
                UserName: [
                    { required: true, message: '请输入姓名', trigger: 'blur' },
                ],
                Unit: [
                    { required: true, message: '请输入单位', trigger: 'blur' },
                ],
                SignUpTime: [
                    { required: true, message: '请输入报名时间', trigger: 'blur' },
                ],
                ComeOnGroup: [
                    { required: true, message: '请选择组别', trigger: 'blur' },
                ]
            },
            optionalGroups: [],
            matchRegions: [],
            editMatchRegions: [],
            editMatchRegionRadio: -1,
            exceptionProjects: [],
            arrangeRuleData: [],
            ArrangeRuleOverviewData: [],
            windowHeight: '100%',
            matchProjectTimeConfig: {},
            projectTimeTakenConfigDialogVisible: false,
            matchProjectTimeTakenConfig: {},
            allUnits: [],
            signUpFormStatus: null,
            matchSchedule: []
        }
    },
    watch: {
        '$route'(to, from) {
            this.initMatchDetail();
            this.initRefereeType();
            this.getMatchWholeSchedule();
            this.getMatchSchedule();
            this.getMatchProjectTimeConfig();

        }
    },
    beforeDestroy() {
        this.matchWholeSchedule = null;
        this.projects = null;
    },
    created() {
        this.initMatchDetail();
        this.initRefereeType();
        this.getMatchWholeSchedule();
        this.getMatchSchedule();
        this.getMatchProjectTimeConfig();
        this.windowHeight = window.innerHeight - 200 + 'px'
    },
    methods: {
        marryKey(text, searchKey) {
            return !searchKey || text.indexOf(searchKey) > -1
        },
        initRefereeType() {
            MatchService.selectRefereeTypeList().then(res => {
                if (res.code == 0) this.allRefereeType = res.data;
            })
        },

        initMatchRegions() {
            MatchService.selectMatchRegions({ matchId: this.routeMatchId }).then(res => {
                if (res.code == 0) this.matchRegions = res.data;
            })
        },

        initMatchDetail() {
            let id = this.$route.params.id;
            if (id) {
                this.$store.commit('matchIdCookie', id);
                this.choiceMatchDialogVisible = false;
                this.routeMatchId = id;
                this.getMatchDetail(id);
                this.initMatchRegions();
                //this.chechProjectArrangeStatus(id);
            } else {
                if (this.$store.state.matchIdCookie) {
                    this.$router.replace('/mainpage/match-arrange/' + this.$store.state.matchIdCookie);
                } else {
                    //弹框选择赛事
                    this.choiceMatchDialogVisible = true;
                }
            }

            this.getAllMatchs();
        },
        confirmChoiceMatch() {
            if (this.matchId) {
                this.$store.commit('matchIdCookie', this.matchId);
                this.$router.replace('/mainpage/match-arrange/' + this.matchId);
            } else {
                this.$message.error('请选择赛事');
            }

        },
        chechProjectArrangeStatus(id) {
            console.log('chechProjectArrangeStatus');
            MatchService.chechProjectArrangeStatus({ matchId: id }).then(res => {
                if (res.code == 0) {
                    this.exceptionProjects = res.data;
                    if (this.exceptionProjects && this.exceptionProjects.length > 0) {
                        let err = '';
                        this.exceptionProjects.forEach(element => {
                            err += (element.GroupName + element.GenderRuleText + element.ProjectName + '<br />')
                        });

                        this.$notify({
                            type: 'warning',
                            title: '提示',
                            dangerouslyUseHTMLString: true,
                            message: '<strong>当前存在编排每组人数与项目设置人数不符的项目:</strong> <br />' + err,
                            duration: 5000,
                            offset: 100
                        });
                    }
                }
            });
        },
        getMatchDetail(id) {
            this.allLoading = true;
            MatchService.getMatchDetail({ matchId: id }).then(res => {
                this.allLoading = false;
                if (res.code == 0) {

                    if (res.data == null) {
                        this.$message.warning('赛事不存在或已被删除');
                        setTimeout(() => {
                            this.$router.push('/mainpage/match-manage');
                        }, 1500);
                    } else {
                        this.match = res.data;
                        //this.MatcheditUserForm.MatchSignUpTimes = [];
                        this.match.Files = this.match.Files == null ? [] : this.match.Files;
                        this.match.SignUpStartTime = this.match.SignUpStartTime.replace('T', ' ');
                        this.match.SignUpEndTime = this.match.SignUpEndTime.replace('T', ' ');
                        this.match.StartTime = this.match.StartTime.replace('T', ' ');
                        this.match.EndTime = this.match.EndTime.replace('T', ' ');

                        this.match.MatchGroups = res.data.MatchGroups;

                        this.match.MatchGroups.forEach(item => {
                            item.Projects.forEach(project => {
                                project.GenderRuleText = this.GenderRuleList.find(r => r.value == project.GenderRule).label;
                                project.SignUpMaxPeopleNumText = project.SignUpLimitNum == 0 ? '不限' : '限报' + project.SignUpLimitNum + (project.SignUpLimitType == 1 ? '人' : '队');
                                // project.RefereePeopleConfig.forEach(r => {
                                //     project.RefereePeople += r.RefereeTypeName + '*' + r.RefereePeopleNum + '   ';
                                // })
                            });
                        });
                    }

                }
            });
        },
        getMatchWholeSchedule() {
            if (this.routeMatchId != '') {
                MatchService.getMatchWholeSchedule({ matchId: this.routeMatchId, isExistsUser: 1 }).then(res => {
                    if (res.code == 0) {
                        this.matchWholeSchedule = res.data;
                        res = null;
                    }
                });
            }
        },
        getMatchSchedule() {
            if (this.routeMatchId != '') {
                MatchService.getMatchSchedule({ matchId: this.routeMatchId }).then(res => {
                    if (res.code == 0) {
                        this.matchSchedule = res.data;
                        res = null;
                    }
                });
            }
        },

        getMatchProjectTimeConfig() {
            if (this.routeMatchId != '') {
                MatchService.getMatchProjectTimeConfig({ matchId: this.routeMatchId, reset: 1 }).then(res => {
                    if (res.code == 0) this.matchProjectTimeConfig = res.data;
                })
            }
        },
        showProjectTimeTakenConfigDialog() {
            this.getMatchProjectTimeTakenConfig(0);
            this.projectTimeTakenConfigDialogVisible = true;
        },
        getMatchProjectTimeTakenConfig(reset) {
            if (this.routeMatchId != '') {
                MatchService.getMatchProjectTimeTakenConfig({ matchId: this.routeMatchId, reset: reset }).then(res => {
                    if (res.code == 0) this.matchProjectTimeTakenConfig = res.data;
                })
            }
        },
        submitEditMatchProjectTimeTakenConfig() {
            this.matchProjectTimeTakenConfig.forEach(item => {
                if (!item.TimeValue) {
                    this.$message.warning('请输入项目时间');
                    return;
                }
            })

            MatchService.setMatchProjectReferenceTime(this.matchProjectTimeTakenConfig).then(res => {
                if (res.code == 0) {
                    this.$message.success('更新成功');
                    this.getMatchSchedule();
                    this.getMatchWholeSchedule();
                    this.projectTimeTakenConfigDialogVisible = false;
                }
            })
        },
        submitEditMatchProjectTimeTakenConfig2() {
            this.matchProjectTimeTakenConfig.forEach(item => {
                if (!item.TimeValue) {
                    this.$message.warning('请输入项目时间');
                    return;
                }
            })

            MatchService.setMatchProjectReferenceTime2(this.matchProjectTimeTakenConfig).then(res => {
                if (res.code == 0) {
                    this.$message.success('更新成功');
                    this.getMatchSchedule();
                    this.getMatchWholeSchedule();
                    this.projectTimeTakenConfigDialogVisible = false;
                }
            })
        },
        clearMatchProjectReferenceTime() {
            this.$confirm('确认清空参考时间吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                MatchService.clearMatchProjectReferenceTime({ matchId: this.routeMatchId, venueId: '' }).then(res => {
                    if (res.code == 0) {
                        this.$message.success('清空成功');
                        this.getMatchSchedule();
                        this.getMatchWholeSchedule();
                    }
                })
            });
        },
        exportMatchProjectTime() {
            MatchService.exportMatchProjectTime({ matchId: this.routeMatchId }).then(res => {
                if (res.code == 0) {
                    this.$message.success('导出成功');
                    location.href = Url.getDownloadBaseUrl() + '/exportfiles/' + res.data;
                }
            })
        },
        exportMatchProjectTime2() {
            MatchService.exportMatchProjectTime2({ matchId: this.routeMatchId }).then(res => {
                if (res.code == 0) {
                    this.$message.success('导出成功');
                    location.href = Url.getDownloadBaseUrl() + '/exportfiles/' + res.data;
                }
            })
        },
        showSetArrangeRuleDialog() {

            if (this.routeMatchId != '') {
                MatchService.getMatchWholeSchedule({ matchId: this.routeMatchId, isExistsUser: 0 }).then(res => {
                    if (res.code == 0) {
                        this.arrangeRuleData = res.data;
                        if (this.arrangeRuleData) {
                            this.arrangeRuleData.forEach(e => {
                                e['ArrangeNum'] = 1;
                            })
                        }
                        console.log(this.arrangeRuleData)
                        res = null;
                    }
                });
            }

            this.setArrangeRuleDialogVisible = true;
        },

        remoteMethod(query) {
            if (query !== '') {
                this.matchOptions = this.allMatchs.filter(item => {
                    return item.MatchName.indexOf(query) > -1
                })
            } else {
                this.matchOptions = this.allMatchs
            }

        },
        getAllMatchs() {
            MatchService.selectMatchListByName({ matchName: '', signupStatus: '', matchStatus: '' }).then(res => {
                if (res.code == 0) {
                    this.allMatchs = res.data;
                    this.matchOptions = this.allMatchs
                }
            })
        },
        showSetFrequencyDialog() {
            this.getMatchVenue();
            this.setFrequencyDialog = true;
            this.initVenueForm(null, -1);

        },
        getMatchVenue() {
            let data = { matchId: this.routeMatchId };
            MatchService.selectMatchVenueConfig(data).then(res => {
                if (res.code == 0) {
                    this.frequencyData = res.data;
                }
            })
        },
        initVenueForm(data, index) {
            this.venueFormIndex = index;
            if (data) {
                this.venueForm.VenueId = data.VenueId;
                this.venueForm.VenueName = data.VenueName;
                this.venueForm.VenueTime = data.VenueTime;
                this.venueForm.VenueEndTime = data.VenueEndTime;
                this.venueForm.VenueSort = data.VenueSort;
                this.venueSubmitBtnText = '修改';
            } else {
                this.venueForm = {
                    VenueId: '',
                    MatchId: this.routeMatchId,
                    VenueName: '',
                    VenueTime: '',
                    VenueEndTime: '',
                    VenueSort: 0
                };
                this.venueSubmitBtnText = '新增';
            }

        },
        editVenue() {
            this.$refs.venueForm.validate((valid) => {
                if (valid) {
                    let data = [];
                    this.venueForm.VenueTime = Common.formatDate(this.venueForm.VenueTime, 'YYYY-MM-DDTHH:mm:ss')
                    this.venueForm.VenueEndTime = Common.formatDate(this.venueForm.VenueEndTime, 'YYYY-MM-DDTHH:mm:ss')
                    this.frequencyData.forEach(item => {
                        data.push({
                            VenueId: item.VenueId,
                            MatchId: item.MatchId,
                            VenueName: item.VenueName,
                            VenueTime: item.VenueTime,
                            VenueEndTime: item.VenueEndTime,
                            VenueSort: item.VenueSort
                        })
                    })
                    if (this.venueFormIndex > -1) {
                        data[this.venueFormIndex].VenueName = this.venueForm.VenueName;
                        data[this.venueFormIndex].VenueTime = this.venueForm.VenueTime;
                        data[this.venueFormIndex].VenueEndTime = this.venueForm.VenueEndTime;

                    } else {
                        data.push(this.venueForm);
                    }
                    this.allLoading = true;
                    MatchService.editMatchVenueConfigs(data).then(res => {
                        this.allLoading = false;
                        if (res.code == 0) {
                            this.$message.success(res.data);
                            this.getMatchVenue();
                            this.initVenueForm(null, -1);
                        } else {
                            this.getMatchVenue();
                        }
                    })
                }

            });
        },
        deleteVenue(row) {
            this.$confirm('确定删除该场次吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.allLoading = true;
                MatchService.deleteMatchVenueConfig({ venueId: row.VenueId }).then(res => {
                    this.allLoading = false;
                    if (res.code == 0) {
                        this.$message.success('删除成功');
                        this.getMatchVenue();
                        this.initVenueForm(null, -1);
                    }
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            })
        },
        setVenueSort(index, type) {
            let data = [];
            this.frequencyData.forEach(item => {
                data.push({
                    VenueId: item.VenueId,
                    MatchId: item.MatchId,
                    VenueName: item.VenueName,
                    VenueTime: item.VenueTime,
                    VenueEndTime: item.VenueEndTime,
                    VenueSort: item.VenueSort
                })
            })

            let moveData = {
                VenueId: data[index].VenueId,
                MatchId: data[index].MatchId,
                VenueName: data[index].VenueName,
                VenueTime: data[index].VenueTime,
                VenueEndTime: data[index].VenueEndTime,
                VenueSort: data[index].VenueSort
            }
            let targetIndex = type == 'top' ? index - 1 : index + 1;

            let targetData = {
                VenueId: data[targetIndex].VenueId,
                MatchId: data[targetIndex].MatchId,
                VenueName: data[targetIndex].VenueName,
                VenueTime: data[targetIndex].VenueTime,
                VenueEndTime: data[targetIndex].VenueEndTime,
                VenueSort: data[targetIndex].VenueSort
            }
            data[index] = targetData;
            data[targetIndex] = moveData;
            this.allLoading = true;
            MatchService.editMatchVenueConfigs(data).then(res => {
                this.allLoading = false;
                if (res.code == 0) {
                    // this.$message.success(res.data);
                    this.getMatchVenue();
                }
            })

        },
        dataformatter(row, column, value) {
            return Common.formatDate(value, 'YYYY-MM-DD HH:mm:ss')
        },

        initProjectGrouping() {
            this.projectGroupingDialog = true;
            this.allLoading = true;
            this.checkSignUpFormStatus();
            MatchService.getMatchScheduleUser({ matchId: this.routeMatchId }).then(res => {
                this.allLoading = false;
                if (res.code == 0) {
                    this.venues = res.data;
                    this.venues.forEach(venue => {
                        venue.ProjectMergeGroups.forEach(element => {
                            element.MatchRegions.forEach(region => {
                                if (region.ContestantUserGroups != null) {
                                    region.ContestantUserGroups.forEach(item => {
                                        let len = item.ContestantUsers.length;
                                        let insLen = 10 - len;
                                        for (let index = 0; index < insLen; index++) {
                                            item.ContestantUsers.push({
                                                UserId: '',
                                                UserName: '',
                                                ComeOnGroup: item.GroupNum,
                                                ComeOnNum: '',
                                                ProjectId: element.ProjectId,
                                                Status: 0
                                            })
                                        }
                                        //补一个空位
                                        if (item.ContestantUsers[item.ContestantUsers.length - 1].UserId != '') {
                                            item.ContestantUsers.push({
                                                UserId: '',
                                                UserName: '',
                                                ComeOnGroup: item.GroupNum,
                                                ComeOnNum: '',
                                                ProjectId: element.ProjectId,
                                                Status: 0
                                            })
                                        }
                                    })
                                }
                            });
                        });
                    });
                    res = null;
                }
            }).finally(() => {
                this.allLoading = false;
            });
        },
        projectArrange(proId = '') {
            this.$confirm('是否要重新编排？').then(() => {
                let data = {
                    ProjectId: proId,
                    OrderType: this.arrangeOrderType,
                    Projects: []
                }


                this.projects.forEach(item => {
                    data.Projects.push({
                        MatchId: item.MatchId,
                        ProjectId: item.ProjectId,
                        RegionIds: item.RegionIdArr.join(','),
                        ArrangeType: item.ArrangeType,
                        ArrangeNum: item.ArrangeNum
                    })
                })
                this.allLoading = true;
                MatchService.projectArrange(data).then(res => {
                    this.allLoading = false;
                    if (res.code == 0) {
                        this.$message.success('编排成功');
                        this.initProjectGrouping();
                    }
                }).catch(() => {
                    this.allLoading = false;
                });
            });
        },

        projectArrangeV2(configId = '') {
            // this.$confirm('是否要重新编排？').then(() => {
            //     let data = {
            //         MatchId: this.routeMatchId,
            //         Key: configId,
            //         OrderType: this.arrangeOrderType,
            //         Type: configId == '' ? 'ALL' : 'Group'
            //     }

            //     this.allLoading = true;
            //     MatchService.projectArrangeV2(data).then(res => {
            //         this.allLoading = false;
            //         if (res.code == 0) {
            //             this.$message.success('编排成功');
            //             this.initProjectGrouping();
            //         }
            //     }).catch(() => {
            //         this.allLoading = false;
            //     });
            // });


            this.$prompt('是否确认要编排”' + this.match.MatchName + '“运动员顺序，输入操作密码确认', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                inputPlaceholder: '操作密码'
            }).then(({ value }) => {
                let data = {
                    MatchId: this.routeMatchId,
                    Key: configId,
                    OrderType: this.arrangeOrderType,
                    Type: configId == '' ? 'ALL' : 'Group',
                    Password: value
                }

                this.allLoading = true;
                MatchService.projectArrangeV2(data).then(res => {
                    this.allLoading = false;
                    if (res.code == 0) {
                        this.$message.success('编排成功');
                        this.initProjectGrouping();
                    }
                }).catch(() => {
                    this.allLoading = false;
                });
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '取消输入'
                });
            });
        },
        handleDoubleClickUser(groupId, regionName, regionId, user, index) {
            if (user.UserId == '' && this.exchangeUsers.UserId == '') {
                return;
            }

            if ((this.exchangeUsers.UserId != '' && this.exchangeUsers.UserId == user.UserId) || (this.exchangeUsers.UserId != '' && this.exchangeUsers.MergeConfigId != groupId)) {
                this.exchangeUsers = {
                    UserId: '',
                    ComeOnNum: 0,
                    MergeConfigId: '',
                    ComeOnGroup: 0,
                    ComeOnRegion: '',
                    RegionName: '',
                    Status: 0
                };

                return;
            }

            if (this.exchangeUsers.UserId == '' || (this.exchangeUsers.UserId != '' && this.exchangeUsers.MergeConfigId != groupId)) {
                this.exchangeUsers = {
                    UserId: user.UserId,
                    ComeOnNum: index + 1,
                    MergeConfigId: groupId,
                    ComeOnGroup: user.ComeOnGroup,
                    ComeOnRegion: user.ComeOnRegion,
                    RegionName: user.RegionName,
                    Status: 0
                }
            } else {
                let u1 = this.exchangeUsers;
                let u2 = user;


                let text = '';
                if (u1.UserId != '' && u2.UserId != '') {
                    text = '是否确认将' + u1.RegionName + '第' + u1.ComeOnGroup + '组' + u1.ComeOnNum + '号与' + u2.RegionName + '第' + u2.ComeOnGroup + '组' + (index + 1) + '号对换位置？'
                } else if (u1.UserId != '' && u2.UserId == '') {
                    text = '是否确认将' + u1.RegionName + '第' + u1.ComeOnGroup + '组' + u1.ComeOnNum + '号移到' + regionName + '第' + u2.ComeOnGroup + '组？'
                }
                this.$confirm(text).then(() => {
                    this.allLoading = true;
                    MatchService.contestantUserExchange({ sourceUserId: u1.UserId, targetUserId: u2.UserId, targetRegionId: regionId, targetGroupNum: u2.ComeOnGroup }).then(res => {
                        this.allLoading = false;
                        if (res.code == 0) {
                            this.$message.success(res.data);
                            this.exchangeUsers = {
                                UserId: '',
                                ComeOnNum: 0,
                                MergeConfigId: '',
                                ComeOnGroup: 0,
                                ComeOnRegion: user.ComeOnRegion,
                                RegionName: user.RegionName,
                                Status: 0
                            };
                            this.initProjectGrouping();
                        }
                    })

                });
            }

        },
        showSetVenueProDialog() {
            this.initVenueProjectConfig();
            this.setVenueProDialogVisible = true;
        },
        initVenueProjectConfig() {
            this.allLoading = true;
            MatchService.selectVenueProjectConfig({ matchId: this.routeMatchId }).then(res => {
                this.allLoading = false;
                if (res.code == 0) {
                    this.matchVenues = res.data.Venues;
                    this.notSetProjects = res.data.NotSetProjects;
                    this.alreadySetProjects = res.data.AlreadySetProjects;
                    this.venueId = this.matchVenues.length > 0 ? this.matchVenues[0].VenueId : '';
                    this.selectedNotSetProjects = [];
                    this.selectedAlreadySetProjects = [];
                }
            })
        },
        allChecked(type) {

            this.selectedNotSetProjects = [];
            if (type == 1) {
                this.notSetProjects.forEach(element => {
                    if (this.marryKey('【' + element.ProjectTypeName + '】' + element.GroupName + element.GenderRuleText + element.ProjectName, this.searchKey)) {
                        this.selectedNotSetProjects.push(element.ProjectId)
                    }
                });
            }

        },
        alreadySetProjectsAllChecked(type) {
            this.selectedAlreadySetProjects = [];
            if (type == 1) {
                this.alreadySetProjects.forEach(element => {
                    element.MatchVenueProject.forEach(pro => {
                        this.selectedAlreadySetProjects.push(pro.ProjectId);
                    })
                });
            }
        },
        toSet() {
            let idx = 0
            this.alreadySetProjects.forEach((element, index) => {
                if (element.VenueId == this.venueId) {
                    idx = index;
                }
            });

            let arr = this.notSetProjects.filter(a => this.selectedNotSetProjects.indexOf(a.ProjectId) == -1);;
            let arr2 = this.notSetProjects.filter(a => this.selectedNotSetProjects.indexOf(a.ProjectId) > -1);
            this.notSetProjects = arr;
            arr2.forEach(element => {
                this.alreadySetProjects[idx].MatchVenueProject.push({ VenueId: this.venueId, ProjectId: element.ProjectId, Project: element })
            });
            this.selectedNotSetProjects = [];

        },
        cancelSet() {

            this.alreadySetProjects.forEach(element => {
                let arr = element.MatchVenueProject.filter(a => this.selectedAlreadySetProjects.indexOf(a.ProjectId) == -1);
                let arr2 = element.MatchVenueProject.filter(a => this.selectedAlreadySetProjects.indexOf(a.ProjectId) > -1);
                arr2.forEach(pro => {
                    this.notSetProjects.push(pro.Project);
                });
                element.MatchVenueProject = arr;
            });
            this.selectedAlreadySetProjects = [];
        },
        handlerMatchVenueProject() {
            this.allLoading = true;
            MatchService.handlerMatchVenueProject(this.alreadySetProjects).then(res => {
                this.allLoading = false;
                if (res.code == 0) {
                    this.$message.success(res.data);
                    this.getMatchWholeSchedule();
                    this.getMatchSchedule();
                }
            })
        },
        showSetRefereeDialog() {
            if (this.projectTypes.length == 0) {
                MatchService.selectMatchRefereeConfigList({ matchId: this.routeMatchId }).then(res => {
                    if (res.code == 0) {
                        this.projectTypes = res.data;
                        this.projectTypes.forEach(element => {
                            element['RefereeTypes'] = this.allRefereeType;
                        });
                    }

                })
            }



            this.setRefereeDialogVisible = true;
        }, submitEditMatchRefereeConfig() {
            this.projectTypes.forEach(element => {
                element.RefereePeopleConfig.forEach(c => {
                    if (c.RefereePeopleNum == '') c.RefereePeopleNum = 0;
                });
            });

            MatchService.editMatchRefereeConfig(this.projectTypes).then(res => {
                if (res.code == 0) {
                    this.$message.success(res.data);
                    this.setRefereeDialogVisible = false;
                }
            })
        },
        addRegion(pro) {
            pro.Regions.push({
            })
        },
        handAddRegion(e) {
            console.log(e.group.MatchRegions);
            e.group.MatchRegions.push(e.region);
            e.group.MatchRegions = e.group.MatchRegions.sort((a, b) => {
                return a.RegionSort - b.RegionSort
            });

        },
        addGroup(rs, r) {

            let groupNum = 1;
            let groups = [];
            //获取最大组别号数
            rs.forEach(item => {
                if (item.ContestantUserGroups) {
                    item.ContestantUserGroups.forEach(g => {
                        groups.push(g.GroupNum);
                    })
                }
            });
            groupNum = groups.length == 0 ? 1 : groups.sort((a, b) => b - a)[0] + 1;

            if (!r.ContestantUserGroups) {
                r.ContestantUserGroups = [];
            }
            let users = [];
            for (let index = 0; index < 10; index++) {
                users.push({
                    UserId: '',
                    UserName: '',
                    ComeOnRegion: r.RegionId,
                    ComeOnGroup: groupNum,
                    ComeOnNum: '',
                    ProjectId: '',
                    Status: 0
                })
            }

            r.ContestantUserGroups.push({
                GroupNum: groupNum,
                ContestantUsers: users
            })
        },
        submitSignUpForm() {
            this.$refs['editUserForm'].validate((valid) => {
                if (valid) {
                    this.editUserForm.SignUpTime = Common.formatDate(this.editUserForm.SignUpTime, 'YYYY-MM-DDTHH:mm:ss');
                    let pro = this.editProjects.find(a => a.ProjectId == this.editUserForm.ProjectId);
                    this.editUserForm.GroupId = pro.GroupId;
                    this.editUserForm.Gender = pro.GenderRule;
                    MatchService.editMatchContestantUser(this.editUserForm).then(res => {
                        if (res.code == 0) {
                            this.$message.success(res.data);
                            this.editSignUpDialogVisible = false;
                            this.initProjectGrouping();
                        }
                    })
                }
            });
        },
        showEditUserDialog(pros, r) {
            this.editSignUpDialogVisible = true;
            this.editProjects = pros;
            this.optionalGroups = [];
            r.ContestantUserGroups.forEach(g => {
                if (g.ContestantUsers.filter(a => a.UserId != '' && a.Status > 0).length == 0) {
                    this.optionalGroups.push({ label: '第' + g.GroupNum + '组', value: g.GroupNum })
                }
            })

            MatchService.selectMatchRelatUnitNameList({ matchId: this.routeMatchId }).then(res => {
                if (res.code == 0) {
                    this.allUnits = [];
                    res.data.forEach(item => {
                        this.allUnits.push({
                            address: item,
                            value: item,
                        });
                    })
                }
            })
            this.editUserForm = {
                UserId: '',
                UserName: '',
                // Gender: pro.GenderRule,
                Birthday: null,
                MatchId: this.routeMatchId,
                // GroupId: pros.length > 0? pros[0].GroupId:'',
                ProjectId: '',
                IdentityCard: '',
                Unit: '',
                Remarks: '',
                RegionName: r.RegionName,
                ComeOnRegion: r.RegionId,
                ComeOnGroup: null,
                ComeOnNum: 0,
                SignUpTime: new Date()
            }
        },
        showSetRegionDialog() {
            this.editMatchRegions = Common.copyObj(this.matchRegions);
            this.editMatchRegions.forEach((element, index) => {
                if (element.IsDefault == 1) {
                    this.editMatchRegionRadio = index;
                }
            });
            this.setRegionDialogVisible = true;
        },
        insertMatchRegion() {
            this.editMatchRegions.push({
                MatchId: this.routeMatchId,
                RegionName: '',
                IsDefault: 0
            })
        },
        initRegionForm(data, index) {
            this.regionFormIndex = index;
            if (data) {
                this.regionForm.RegionName = data.RegionName;
                this.regionForm.RegionId = data.RegionId;
                this.regionForm.MatchId = data.MatchId;
                this.regionForm.IsDefault = data.IsDefault;
                this.regionForm.RegionSort = data.RegionSort;
                this.regionSubmitBtnText = '修改';
            } else {
                this.regionForm.RegionName = '';
                this.regionForm.RegionId = '';
                this.regionForm.MatchId = '';
                this.regionForm.IsDefault = 0;
                this.regionForm.RegionSort = 0;
                this.regionSubmitBtnText = '新增';
            }

        },
        deleteRegion(row) {
            this.$confirm('确定删除该区域吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.allLoading = true;
                MatchService.delMatchRegionInfo({ regionId: row.RegionId }).then(res => {
                    this.allLoading = false;
                    if (res.code == 0) {
                        this.$message.success('删除成功');
                        this.initMatchRegions();
                        this.initRegionForm(null, -1);
                    }
                })
            }).catch((err) => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            })
        },
        editRegion() {
            this.$refs.regionForm.validate((valid) => {
                if (valid) {
                    let data = [];
                    this.matchRegions.forEach(item => {
                        data.push({
                            RegionId: item.RegionId,
                            MatchId: this.routeMatchId,
                            RegionName: item.RegionName,
                            IsDefault: this.regionForm.IsDefault == 1 ? 0 : item.IsDefault,
                            RegionSort: item.RegionSort,
                        })
                    })
                    if (this.regionFormIndex > -1) {
                        data[this.regionFormIndex].RegionName = this.regionForm.RegionName;
                        data[this.regionFormIndex].IsDefault = this.regionForm.IsDefault;
                    } else {
                        data.push(this.regionForm);
                    }

                    if (this.regionForm.IsDefault == 1) {
                        if (this.regionFormIndex > -1) {
                            data[this.regionFormIndex].IsDefault = this.regionForm.IsDefault;
                        }
                    }

                    this.allLoading = true;
                    MatchService.editMatchRegions(data).then(res => {
                        this.allLoading = false;
                        if (res.code == 0) {
                            this.$message.success(res.data);
                            this.initMatchRegions();
                            this.initRegionForm(null, -1);
                        } else {
                            this.initMatchRegions();
                        }
                    })
                }

            });
        },
        setRegionSort(index, type) {
            let data = Common.copyObj(this.matchRegions);


            let moveData = Common.copyObj(this.matchRegions[index]);
            let targetIndex = type == 'top' ? index - 1 : index + 1;

            let targetData = Common.copyObj(this.matchRegions[targetIndex]);
            data[index] = targetData;
            data[targetIndex] = moveData;
            this.allLoading = true;
            MatchService.editMatchRegions(data).then(res => {
                this.allLoading = false;
                if (res.code == 0) {
                    this.$message.success(res.data);
                    this.initMatchRegions();
                }
            })

        },

        setVenueProjectSort(event, index, subIndex, type) {
            //防止冒泡
            event.stopPropagation()

            if (type == 'top' && subIndex > 0) {
                console.log(type);
                //操作行
                let temp = this.alreadySetProjects[index].MatchVenueProject[subIndex];
                this.alreadySetProjects[index].MatchVenueProject[subIndex] = this.alreadySetProjects[index].MatchVenueProject[subIndex - 1];
                this.alreadySetProjects[index].MatchVenueProject[subIndex - 1] = temp;
                console.log(this.alreadySetProjects[index].MatchVenueProject[subIndex].Project.GroupName);
                this.$forceUpdate();
            } else if (type == 'bottom' && subIndex < this.alreadySetProjects[index].MatchVenueProject.length - 1) {
                let temp = this.alreadySetProjects[index].MatchVenueProject[subIndex];
                this.alreadySetProjects[index].MatchVenueProject[subIndex] = this.alreadySetProjects[index].MatchVenueProject[subIndex + 1];
                this.alreadySetProjects[index].MatchVenueProject[subIndex + 1] = temp;
                this.$forceUpdate();
            }
        },

        setVenueProjectSort2(event, index, subIndex, type) {
            //防止冒泡
            event.stopPropagation()

            if (type == 'top' && subIndex > 0) {
                let temp = this.arrangeRuleData[index].MatchVenueProject[subIndex];
                // this.arrangeRuleData[index].MatchVenueProject[subIndex] = this.arrangeRuleData[index].MatchVenueProject[subIndex - 1];
                // this.arrangeRuleData[index].MatchVenueProject[subIndex - 1] = { ...temp };
                this.$set(this.arrangeRuleData[index].MatchVenueProject, subIndex, this.arrangeRuleData[index].MatchVenueProject[subIndex - 1]);
                this.$set(this.arrangeRuleData[index].MatchVenueProject, subIndex - 1, temp);
            } else if (type == 'bottom' && subIndex < this.arrangeRuleData[index].MatchVenueProject.length - 1) {
                let temp = this.arrangeRuleData[index].MatchVenueProject[subIndex];
                // this.arrangeRuleData[index].MatchVenueProject[subIndex] = this.arrangeRuleData[index].MatchVenueProject[subIndex + 1];
                // this.arrangeRuleData[index].MatchVenueProject[subIndex + 1] = { ...temp };
                this.$set(this.arrangeRuleData[index].MatchVenueProject, subIndex, this.arrangeRuleData[index].MatchVenueProject[subIndex + 1]);
                this.$set(this.arrangeRuleData[index].MatchVenueProject, subIndex + 1, temp);
            }

        },

        exportMatchSchedule() {
            this.allLoading = true;
            MatchService.exportMatchSchedule({ matchId: this.routeMatchId }).then(res => {
                this.allLoading = false;
                if (res.code == 0) {
                    this.$message.success('导出成功')
                    location.href = Url.getDownloadBaseUrl() + '/exportfiles/' + res.data;
                }
            }).finally(() => {
                this.allLoading = false;
            })
        },
        exportMatchWholeSchedule() {
            this.allLoading = true;
            MatchService.exportMatchWholeSchedule({ matchId: this.routeMatchId }).then(res => {
                this.allLoading = false;
                if (res.code == 0) {
                    this.$message.success('导出成功')
                    location.href = Url.getDownloadBaseUrl() + '/exportfiles/' + res.data;
                }
            }).finally(() => {
                this.allLoading = false;
            })
        },

        ReferenceTimeChange(pro) {
            MatchService.setProReferenceTime({ proId: pro.ProjectId, referenceTime: pro.ReferenceTime == null ? pro.ReferenceTime : utilsCommon.formatDate(pro.ReferenceTime, 'YYYY-MM-DD HH:mm:ss') }).then(res => {
                if (res.code == 0) {
                    this.$message.success(res.data);
                }
            })
        },
        ReferenceTimeChange2(config) {
            MatchService.setProReferenceTime2({ configId: config.ConfigId, referenceTime: config.ReferenceTime == null ? config.ReferenceTime : utilsCommon.formatDate(config.ReferenceTime, 'YYYY-MM-DD HH:mm:ss') }).then(res => {
                if (res.code == 0) {
                    this.$message.success(res.data);
                }
            })
        },
        matchArrangeOverview() {
            this.arrangeRuleData.forEach(v => {
                v.MatchVenueProject.forEach(vp => {
                    vp.Project.RegionIds = vp.Project.RegionIdArr.sort().join(',');
                });
            });
            MatchService.matchArrangeOverview(this.arrangeRuleData).then(resData => {
                if (resData.code == 0) {
                    this.ArrangeRuleOverviewData = resData.data;
                    this.arrangeRuleOverviewDialogVisible = true;
                }
            })
        },
        submitArrangeRule() {
            // this.arrangeRuleData.forEach(v => {
            //     v.MatchVenueProject.forEach(vp => {
            //         vp.Project.RegionIds = vp.Project.RegionIdArr.sort().join(',');
            //     });
            // });
            MatchService.submitArrangeRule(this.arrangeRuleData).then(resData => {
                if (resData.code == 0) {
                    this.$message.success(resData.data);
                    this.arrangeRuleOverviewDialogVisible = false;
                    this.setArrangeRuleDialogVisible = false;
                }
            })
        },
        querySearch(queryString, cb) {
            var restaurants = this.allUnits;
            var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
            // 调用 callback 返回建议列表的数据
            cb(results);
        },
        createFilter(queryString) {
            return (restaurant) => {
                return (restaurant.value.indexOf(queryString) > -1);
            };
        },
        checkSignUpFormStatus() {
            MatchService.checkSignUpFormStatus({ matchId: this.routeMatchId }).then(res => {
                if (res.code == 0) {
                    this.signUpFormStatus = res.data;
                }
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.opr-btn {
    margin-top: 30px;
}

.el-row {
    margin-bottom: 20px;

    &:last-child {
        margin-bottom: 0;
    }
}

.el-col {
    border-radius: 4px;
}

.bg-purple-dark {
    background: #99a9bf;
}

.bg-purple {
    background: #d3dce6;
}

.bg-purple-light {
    background: #e5e9f2;
}

.grid-content {
    border-radius: 4px;
    min-height: 36px;
}

.row-bg {
    padding: 10px 0;
    background-color: #f9fafc;
}

.clearfix {
    height: 30px;
}

.box-card {
    width: 100px;
}

.el-descriptions__header {
    width: 100%;
    /* 确保表头宽度为 100% */
}



/* 如果需要更精确的控制，可以指定具体宽度 */
.el-descriptions__body {
    grid-template-columns: 150px 150px 150px;
    /* 每列具体宽度 */
}
</style>
